<template>
    <div class="comparison-table">
        <div class="comparison-table__table">
            <table>
                <thead>
                    <tr>
                        <th
                            v-for="(header, headerIndex) in headers"
                            :key="'header_' + headerIndex"
                        >
                            {{ formatHeader(header) }}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
                        <template v-for="(rowKey, index) in Object.keys(row)">
                            <td
                                :key="index"
                                v-if="rowKey.toLowerCase() === 'provider'"
                                class="provider"
                            >
                                {{ providerMedal(rowIndex) }}
                                <a
                                    :href="gotoLinkByProviderIndex(rowIndex)"
                                    target="_blank"
                                >
                                    {{ row[rowKey] }}
                                </a>
                            </td>

                            <td :key="index" v-else v-html="row[rowKey]"></td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { ghostWriterRankingMixin, mediaQueriesMixin } from '@/ghost-mixins';

export default {
    name: 'ComparisonTable',
    mixins: [mediaQueriesMixin, ghostWriterRankingMixin],
    props: {
        content: {},
        providers: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        formatHeader(title) {
            return title.replaceAll('_', ' ');
        },
        providerMedal(index) {
            if (index === 0) return '🥇';
            if (index === 1) return '🥈';
            if (index === 2) return '🥉';
            return '';
        },
    },
    computed: {
        rows() {
            try {
                if (this.isMobile()) return this.content.mobile.table.Rows;
                return this.content.desktop.table.Rows;
            } catch (e) {
                return [];
            }
        },
        headers() {
            try {
                if (this.isMobile()) return this.content.mobile.table.Headers;
                return this.content.desktop.table.Headers;
            } catch (e) {
                return [];
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';
.comparison-table {
    border: 1px solid var(--gw-discount-btn-border-color);
    border-radius: 12px;
    overflow: hidden;
    line-height: 1.25;

    &__table {
        position: relative;
        overflow: scroll;
        width: 100%;
        max-width: 780px;
    }

    table {
        width: 100%;
        caption-side: bottom;
        border-collapse: collapse;
        font-size: 12px;
        position: relative;
        overflow: auto;
        border-spacing: 0;

        @include mq('tablet') {
            font-size: 14px;
        }

        thead {
            tr {
                border-bottom: 1px solid var(--gw-discount-btn-border-color);
                transition-property: color, background-color, border-color,
                    text-decoration-color, fill, stroke;
                transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
                transition-duration: 0.15s;
            }

            th {
                text-align: left;
                vertical-align: middle;
                font-weight: 600;
                padding: 8px 12px;
                text-transform: capitalize;
                line-height: 1.25;
                height: 18px;
                width: auto;
                min-width: 125px;
                color: var(--gw-table-header-text-color);
                background: var(--gw-table-header-bg-color);

                &:first-child {
                    position: sticky;
                    left: 0;
                    z-index: 3;
                }
            }
        }

        tbody {
            tr {
                border-bottom: 1px solid var(--gw-discount-btn-border-color);
                transition: background-color 0.15s ease, color 0.15s ease;

                &:hover {
                    background-color: rgba(0, 0, 0, 0.04);
                }

                &:last-child {
                    border-bottom: 0;
                }
            }

            td {
                padding: 6px 8px;
                vertical-align: middle;
                width: auto;
                border-right: 1px solid var(--gw-discount-btn-border-color);
                color: var(--gw-table-header-text-color);

                @include mq('tablet') {
                    padding: 8px 12px;
                }

                &:last-child {
                    border-right: none;
                }

                &:first-child {
                    position: sticky;
                    left: 0;
                    z-index: 2;
                    color: var(--gw-table-header-text-color);
                    background-color: var(--gw-table-header-bg-color);

                    font-weight: 600;
                }
            }
        }
    }
}
</style>
